import VerticalLayout from '../../components/layouts/VerticalLayout';
import { MaintenanceRequestFields } from '../../graphql/athena/types/MaintenanceRequestFields';
import useGetPhotoRequirements from '../../graphql/queries/web/maintenance/useGetPhotoRequirements';

interface MaintenanceRequestRequirementsProps {
  request: MaintenanceRequestFields;
}

const MaintenanceRequestRequirements = ({ request }: MaintenanceRequestRequirementsProps) => {
  const { data: photoRequirementsData } = useGetPhotoRequirements({
    variables: { requestId: request ? request.id : '' },
    skip: !request,
  });

  const photoRequirements =
    photoRequirementsData?.webMaintenance.getPhotoRequirements?.requirements || [];

  return (
    <VerticalLayout>
      <span style={{ ...styles.text, ...styles.boldText }} className="mb-2">
        Requirements for {request.kind.toLowerCase()}
      </span>
      <ul style={styles.list} data-testid="photo-requirements">
        {photoRequirements.map((requirement: string) => {
          return <li data-testid="photo-requirements-item">{requirement}</li>;
        })}
      </ul>
    </VerticalLayout>
  );
};

export default MaintenanceRequestRequirements;

const styles = {
  text: {
    fontSize: 14,
  },
  boldText: {
    fontWeight: 'bold',
  },
  list: {
    listStyle: 'disc',
    paddingLeft: '2rem',
  },
};
